export default "__VITE_ASSET__df606028__"